// extracted by mini-css-extract-plugin
export var radioInputRow = "y_sq";
export var radioInputColumn = "y_sr";
export var inputOptionRow = "y_qq";
export var inputOptionColumn = "y_qr";